
import { i18nText } from '@/locales';
// @ts-ignore
import Vue from 'vue';
import Component from 'vue-class-component';
import { ITableColumn } from '@/entity/table/table.types';
@Component
export class UsersSettingsTableMix extends Vue {
    get columns(): ITableColumn[] {
        return [
            {
                title: '',
                dataIndex: 'image',
                key: 'image',
                scopedSlots: {
                    customRender: "image",
                }
            },
            {
                title: i18nText("Имя"),
                dataIndex: 'name',
                key: 'name',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Контакты"),
                dataIndex: 'phone',
                key: 'phone',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Роли"),
                dataIndex: 'role',
                key: 'role',
                // dataIndex: 'role',
                // key: 'role',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: 'roles',
                },
            },
            {
                title: i18nText("Студии"),
                dataIndex: 'studio',
                key: 'studio',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: 'studios',
                },
            },
            {
                title: '',
                dataIndex: 'edit',
                key: 'edit',
                scopedSlots: {
                    customRender: "edit",
                }
            },
        ];
    }
}
